import {
  clearAuthState,
  getActiveRefreshToken,
  logoutApi,
} from '@repo/api';

export const logout = async (): Promise<void> => {
  const refreshToken = getActiveRefreshToken();
  if (refreshToken) {
    try {
      await logoutApi(refreshToken);
    } catch {
      // Backend logout failed — still clear local state per spec
    }
  }
  clearAuthState();
};
